import { ContentBoxProps } from './types';
import { cn } from '@/utils/class-utils';

export function ContentBoxFooter({ children, className }: ContentBoxProps) {
  return <div className={cn('content-box-footer', className)}>{children}</div>;
}
